"use strict";

var _extends = Object.assign || function (a) {
  for (var c, b = 1; b < arguments.length; b++) {
    for (var d in c = arguments[b], c) {
      Object.prototype.hasOwnProperty.call(c, d) && (a[d] = c[d]);
    }
  }

  return a;
},
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _deepIs = require("deep-is"),
    _deepIs2 = _interopRequireDefault(_deepIs),
    _clone = require("clone"),
    _clone2 = _interopRequireDefault(_clone),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes);

var _Mathmax = Math.max,
    _Mathmin = Math.min;
Object.defineProperty(exports, "__esModule", {
  value: !0
});

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _objectWithoutProperties(a, b) {
  var c = {};

  for (var d in a) {
    0 <= b.indexOf(d) || Object.prototype.hasOwnProperty.call(a, d) && (c[d] = a[d]);
  }

  return c;
}

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(a, b) {
  if (!a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return b && ("object" == typeof b || "function" == typeof b) ? b : a;
}

function _inherits(a, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function, not " + typeof b);
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : a.__proto__ = b);
}

var TableDragSelect = function (a) {
  function b() {
    var c, d, f, g;

    _classCallCheck(this, b);

    for (var h = arguments.length, k = Array(h), l = 0; l < h; l++) {
      k[l] = arguments[l];
    }

    return g = (d = (f = _possibleConstructorReturn(this, (c = b.__proto__ || Object.getPrototypeOf(b)).call.apply(c, [this].concat(k))), f), f.state = {
      selectionStarted: !1,
      startRow: null,
      startColumn: null,
      endRow: null,
      endColumn: null,
      addMode: null
    }, f.componentDidMount = function () {
      window.addEventListener("mouseup", f.handleTouchEndWindow), window.addEventListener("touchend", f.handleTouchEndWindow);
    }, f.componentWillUnmount = function () {
      window.removeEventListener("mouseup", f.handleTouchEndWindow), window.removeEventListener("touchend", f.handleTouchEndWindow);
    }, f.render = function () {
      var m = f.props,
          n = m.value,
          o = m.onChange,
          p = _objectWithoutProperties(m, ["value", "onChange"]);

      return _react2.default.createElement("table", _extends({
        className: "table-drag-select"
      }, p), _react2.default.createElement("tbody", null, f.renderRows()));
    }, f.renderRows = function () {
      return _react2.default.Children.map(f.props.children, function (m, n) {
        return _react2.default.createElement("tr", _extends({
          key: n
        }, m.props), _react2.default.Children.map(m.props.children, function (o, p) {
          return _react2.default.createElement(Cell, _extends({
            key: p,
            onTouchStart: f.handleTouchStartCell,
            onTouchMove: f.handleTouchMoveCell,
            selected: f.props.value[n][p],
            beingSelected: f.isCellBeingSelected(n, p)
          }, o.props), o.props.children);
        }));
      });
    }, f.handleTouchStartCell = function (m) {
      var n = 0 === m.button,
          o = "mousedown" !== m.type;

      if (!f.state.selectionStarted && (n || o)) {
        m.preventDefault();
        var p = eventToCellLocation(m),
            q = p.row,
            r = p.column;
        f.setState({
          selectionStarted: !0,
          startRow: q,
          startColumn: r,
          endRow: q,
          endColumn: r,
          addMode: !f.props.value[q][r]
        });
      }
    }, f.handleTouchMoveCell = function (m) {
      if (f.state.selectionStarted) {
        m.preventDefault();
        var n = eventToCellLocation(m),
            o = n.row,
            p = n.column;
        f.setState({
          endRow: o,
          endColumn: p
        });
      }
    }, f.handleTouchEndWindow = function (m) {
      var n = 0 === m.button,
          o = "mousedown" !== m.type;

      if (f.state.selectionStarted && (n || o)) {
        for (var p = (0, _clone2.default)(f.props.value), q = _Mathmin(f.state.startRow, f.state.endRow), r = _Mathmax(f.state.startRow, f.state.endRow), s = q; s <= r; s++) {
          for (var t = _Mathmin(f.state.startColumn, f.state.endColumn), u = _Mathmax(f.state.startColumn, f.state.endColumn), v = t; v <= u; v++) {
            p[s][v] = f.state.addMode;
          }
        }

        f.setState({
          selectionStarted: !1
        }), f.props.onChange(p);
      }
    }, f.isCellBeingSelected = function (m, n) {
      var o = _Mathmin(f.state.startRow, f.state.endRow),
          p = _Mathmax(f.state.startRow, f.state.endRow),
          q = _Mathmin(f.state.startColumn, f.state.endColumn),
          r = _Mathmax(f.state.startColumn, f.state.endColumn);

      return f.state.selectionStarted && m >= o && m <= p && n >= q && n <= r;
    }, d), _possibleConstructorReturn(f, g);
  }

  return _inherits(b, a), b;
}(_react2.default.Component);

TableDragSelect.propTypes = {
  value: function value(a) {
    var b = new Error("Invalid prop `value` supplied to `TableDragSelect`. Validation failed.");
    if (!Array.isArray(a.value)) return b;

    if (0 !== a.value.length) {
      var c = a.value[0].length,
          d = !0,
          f = !1,
          g = void 0;

      try {
        for (var k, q, h = a.value[Symbol.iterator](); !(d = (k = h.next()).done); d = !0) {
          if (q = k.value, !Array.isArray(q) || q.length !== c) return b;
          var l = !0,
              m = !1,
              n = void 0;

          try {
            for (var p, r, o = q[Symbol.iterator](); !(l = (p = o.next()).done); l = !0) {
              if (r = p.value, "boolean" != typeof r) return b;
            }
          } catch (r) {
            m = !0, n = r;
          } finally {
            try {
              !l && o.return && o.return();
            } finally {
              if (m) throw n;
            }
          }
        }
      } catch (q) {
        f = !0, g = q;
      } finally {
        try {
          !d && h.return && h.return();
        } finally {
          if (f) throw g;
        }
      }
    }
  },
  onChange: _propTypes2.default.func,
  children: function children(a) {
    if (!TableDragSelect.propTypes.value(a)) {
      var b = new Error("Invalid prop `children` supplied to `TableDragSelect`. Validation failed."),
          c = _react2.default.Children.toArray(a.children),
          d = a.value.length,
          f = 0 === a.value.length ? 0 : a.value[0].length;

      if (c.length !== d) return b;
      var g = !0,
          h = !1,
          k = void 0;

      try {
        for (var m, l = c[Symbol.iterator](); !(g = (m = l.next()).done); g = !0) {
          var s = m.value,
              t = _react2.default.Children.toArray(s.props.children);

          if ("tr" !== s.type || t.length !== f) return b;
          var n = !0,
              o = !1,
              p = void 0;

          try {
            for (var r, u, q = t[Symbol.iterator](); !(n = (r = q.next()).done); n = !0) {
              if (u = r.value, "td" !== u.type) return b;
            }
          } catch (u) {
            o = !0, p = u;
          } finally {
            try {
              !n && q.return && q.return();
            } finally {
              if (o) throw p;
            }
          }
        }
      } catch (s) {
        h = !0, k = s;
      } finally {
        try {
          !g && l.return && l.return();
        } finally {
          if (h) throw k;
        }
      }
    }
  }
}, TableDragSelect.defaultProps = {
  value: [],
  onChange: function onChange() {}
}, exports.default = TableDragSelect;

var Cell = function (a) {
  function b() {
    var c, d, f, g;

    _classCallCheck(this, b);

    for (var h = arguments.length, k = Array(h), l = 0; l < h; l++) {
      k[l] = arguments[l];
    }

    return g = (d = (f = _possibleConstructorReturn(this, (c = b.__proto__ || Object.getPrototypeOf(b)).call.apply(c, [this].concat(k))), f), f.shouldComponentUpdate = function (m) {
      return f.props.beingSelected !== m.beingSelected || f.props.selected !== m.selected;
    }, f.componentDidMount = function () {
      f.td.addEventListener("touchstart", f.handleTouchStart, {
        passive: !1
      }), f.td.addEventListener("touchmove", f.handleTouchMove, {
        passive: !1
      });
    }, f.componentWillUnmount = function () {
      f.td.removeEventListener("touchstart", f.handleTouchStart), f.td.removeEventListener("touchmove", f.handleTouchMove);
    }, f.render = function () {
      var m = f.props,
          n = m.className,
          o = m.disabled,
          p = m.beingSelected,
          q = m.selected,
          r = m.onTouchStart,
          s = m.onTouchMove,
          t = _objectWithoutProperties(m, ["className", "disabled", "beingSelected", "selected", "onTouchStart", "onTouchMove"]);

      return o ? n += " cell-disabled" : (n += " cell-enabled", q && (n += " cell-selected"), p && (n += " cell-being-selected")), _react2.default.createElement("td", _extends({
        ref: function ref(u) {
          return f.td = u;
        },
        className: n,
        onMouseDown: f.handleTouchStart,
        onMouseMove: f.handleTouchMove
      }, t), f.props.children || _react2.default.createElement("span", null, "\xA0"));
    }, f.handleTouchStart = function (m) {
      f.props.disabled || f.props.onTouchStart(m);
    }, f.handleTouchMove = function (m) {
      f.props.disabled || f.props.onTouchMove(m);
    }, d), _possibleConstructorReturn(f, g);
  }

  return _inherits(b, a), b;
}(_react2.default.Component),
    eventToCellLocation = function eventToCellLocation(a) {
  var b;

  if (a.touches) {
    var c = a.touches[0];
    b = document.elementFromPoint(c.clientX, c.clientY);
  } else for (b = a.target; "TD" !== b.tagName;) {
    b = b.parentNode;
  }

  return {
    row: b.parentNode.rowIndex,
    column: b.cellIndex
  };
};